// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductFooter_content__5WSsk","component":"ProductFooter_component__O061N","wrapper":"ProductFooter_wrapper__zVDet","arrow":"ProductFooter_arrow__qo8AO"};